// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Jg8mH","column":"styles_column__2gAD8","row":"styles_row__1OqG4","btn":"styles_btn__2lM-Q"};